import { HUBSPOT_CREDITS_PAGE_REDIRECT } from 'pricing-pages-lib/constants/Gates';
import { useIsUngated } from './useIsUngated';
import { useIsInAppAuth } from '../user/useUserInfo';

/**
 * Returns true when the credits page should redirect away.
 * Always true on public pages (page is removed).
 * On in-app pages, gated behind PPFE:HubspotCreditsPageRedirect.
 */
export const useHubSpotCreditsPageRedirect = () => {
  const isInApp = useIsInAppAuth();
  const isUngated = useIsUngated(HUBSPOT_CREDITS_PAGE_REDIRECT);
  return !isInApp || isUngated;
};